var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCauzeLogo = function SvgCauzeLogo(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5546 8.51673C13.8975 8.51673 15.7968 6.6102 15.7968 4.25837C15.7968 1.90654 13.8975 0 11.5546 0C9.21177 0 7.3125 1.90654 7.3125 4.25837C7.3125 6.6102 9.21177 8.51673 11.5546 8.51673Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3341 7.5954C29.9372 9.91135 27.7293 11.4553 25.4222 11.0569C23.115 10.6584 21.577 8.44209 21.9739 6.12614C22.3708 3.81018 24.5787 2.26622 26.8858 2.66466C29.2178 3.0631 30.7559 5.27945 30.3341 7.5954Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8226 17.5813L31.4504 19.6731C30.0364 27.7665 22.3211 33.1953 14.2586 31.7509C6.19603 30.3315 0.787907 22.5867 2.22676 14.4934L2.59888 12.4015L10.9591 13.8708L10.587 15.9626C9.96682 19.4241 12.2988 22.7362 15.7471 23.3587C19.1954 23.9813 22.4948 21.6404 23.115 18.179L23.4871 16.0871L31.8226 17.5813Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCauzeLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cauze-logo.8351adb73b84637eec2287d3db755384.svg";